var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tipVisible)?_c('HcAlertItem',{staticClass:"top-tip-box",attrs:{"type":_vm.tipInfo.type,"closable":false,"show-icon":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.tipInfo.notice))])]},proxy:true}],null,false,1573126204)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }